import { render, staticRenderFns } from "./EditarEvento.vue?vue&type=template&id=33f52474&scoped=true&lang=pug&"
import script from "./EditarEvento.vue?vue&type=script&lang=js&"
export * from "./EditarEvento.vue?vue&type=script&lang=js&"
import style0 from "./EditarEvento.vue?vue&type=style&index=0&id=33f52474&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f52474",
  null
  
)

export default component.exports